module.exports = {"441702001":"南恩街道","441702002":"城南街道","441702003":"城北街道","441702004":"中洲街道","441702006":"城东街道","441702008":"岗列街道","441702009":"城西街道","441702011":"白沙街道","441702102":"埠场镇","441702103":"平冈镇","441702105":"闸坡镇","441702106":"双捷镇","441702401":"阳江林场罗琴分场","441702450":"平冈农场","441702453":"红十月农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441702.json
// module id = 2042
// module chunks = 0